import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const SNSService = {
    getAllSNS,
    updateSNSStatus,
    getSNS,
    updateSNS,
    createSNS,
};

const MODULE = {
    SNS: 'rnd-product-sds',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'SNS') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export async function getAllSNS(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            product: filter.product,
            name: filter.name,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return await apiHelper(API_URL).get(`/${MODULE.SNS}`, requestOptions)
}


export function updateSNSStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.SNS}/${data.id}`, requestOptions)
}

export function getSNS(id) {
    return apiHelper(API_URL).get(`/${MODULE.SNS}/${id}`)
}

export function updateSNS(data) {
    const formData = new FormData();
    formData.append(`product_uuid`, data.productID);
    formData.append(`name`, data.name);
    formData.append(`_method`, 'PUT');

    if (data.file instanceof File) {
        formData.append(`file`, data.file);
    }

    return apiHelper(API_URL).post(`/${MODULE.SNS}/${data.id}`, formData)
}

export function createSNS(data) {
    const formData = new FormData();
    formData.append(`product_uuid`, data.productID);
    formData.append(`name`, data.name);

    if (data.file instanceof File) {
        formData.append(`file`, data.file);
    }


    return apiHelper(API_URL).post(`/${MODULE.SNS}`, formData)
}